import { render } from "./StockIndexTable.vue?vue&type=template&id=4f9b4b3e"
import script from "./StockIndexTable.vue?vue&type=script&lang=js"
export * from "./StockIndexTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__